import React from "react";
import styled, { css, keyframes } from "styled-components";

export const InfoPairDiv = styled.div`
  margin-bottom: 20px;
  p {
    font-size: 20px;
    margin-bottom: 5px;
  }
`;

export function InfoPair({ title, text, handleNotification, cursor }) {
  const copyToClipboard = (e) => {
    e.target.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };

  return (
    <Title cursor={cursor}>
      <h4>{title}</h4>
      <textarea
        onClick={(e) => copyToClipboard(e)}
        value={text}
        spellCheck="false"
        readOnly="readOnly"
      />
    </Title>
  );
}

const Title = styled.div`
  line-height: 1.4;
  margin-bottom: 20px;
  font-size: 18px;

  h4 {
    text-transform: none;
  }
  p {
    font-family: "GT America, regular";
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  textarea {
    pointer-events: ${(p) => (p.cursor ? "auto" : "none")};
    /* pointer-events:  none; */
    text-transform: none;
    font-family: "GT America, regular";
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 #ffb000;
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: ${(p) => (p.copyCursor ? "auto" : "copy")};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    font-weight: 300;
    scrollbar-width: none;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`;
const animSG1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
     transform:scale(1)
  }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform:scale(.73)
  }
  100%{
    transform:scale(1)
   } 
`;
const animSG = css`
  ${animSG1} 0.3s 1 forwards
`;
const whitOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity:0;
  }
  33%{
    animation-timing-function: cubic-bezier(.15,.36,.2,1);
    opacity:0.5;
   }
  100%{
    opacity:0;
   } 
`;
const whitOpa = css`
  ${whitOpa1} 0.5s 1 forwards
`;
export const Button = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 315px;
  font-size: 20px;
  border-radius: 38px;
  background-color: #ffb000;
  color: #a34ac3;
  margin-bottom: 30px;
  padding: 15px 0 17px;
  animation: ${(p) => (p.animSG ? animSG : null)};
  cursor: pointer;

  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.animSG ? whitOpa : null)};
  }
`;
export function InfoTrio({ betAmount, winCoef, winAmount, currency, prec }) {
  return (
    <Rectangle className="Rectangle">
      <InfoPair
        title={"Bet"}
        text={`${betAmount && betAmount.toFixed(prec)} ${currency}`}
      ></InfoPair>
      <InfoPair
        title={"Payout"}
        text={
          (winCoef === 0 && "0.00x") || (winCoef && winCoef.toFixed(2) + "x")
        }
      ></InfoPair>
      <InfoPair
        title={"Win"}
        text={`${(winAmount === 0 && "0.00") ||
          (winAmount && winAmount.toFixed(prec))} ${currency}`}
      ></InfoPair>
    </Rectangle>
  );
}

const Rectangle = styled.div`
  width: 345px;
  height: 252px;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 32px -15px;
  padding: 24px 15px;
  div {
    height: 55px;
  }
`;
